import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api/api";
import "./stylesheet/CreateTicket.css";
import logoSvg from "../assets/logo.svg"; // Importando a logo padrão

export default function CreateTicketForm() { 
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [sector, setSector] = useState("");
  const [location, setLocation] = useState("");
  const [urgency, setUrgency] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showError, setShowError] = useState(false);

  async function handleSubmit() {
    if (loading) return;
    
    if (!name || !sector || !location || !urgency || !description) {
      setShowError(true);
      return;
    }

    try {
      setLoading(true);
      const response = await api.post("tickets/createTicket.php", {
        name,
        sector,
        location,
        urgency,
        description,
      });

      if (response.data.success) {
        setShowPopup(true);
        setName('');
        setLocation('');
        setDescription('');

        setTimeout(() => {
          setShowPopup(false);
          navigate("/portal");
        }, 2000);
      } else {
        window.alert(`Erro: ${response.data.message}`);
      }
    } catch (error) {
      window.alert("Erro: Falha ao enviar chamado.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="ticket-form-page">
      {/* HEADER PADRONIZADO */}
      <header className="portal-header">
        <div className="header-logo-group" onClick={() => navigate("/portal")} style={{ cursor: "pointer" }}>
          <img src={logoSvg} alt="Logo" className="portal-logo-svg" />
        </div>
        <div className="header-nav-info">
          <button className="back-link-text" onClick={() => navigate("/portal")}>
            Voltar ao Portal
          </button>
        </div>
      </header>

      <div className="form-main-container">
        <div className="form-container">
          <div className="page-intro">
            <h1 className="header-title">Abrir Chamado</h1>
            <p className="page-subtitle">Descreva o problema técnico para que possamos ajudar.</p>
          </div>

          <h2 className="card-main-title">Informações do Chamado</h2>

          <div className="input-group">
            <label className="select-label">Nome da Pessoa *</label>
            <input
              type="text"
              placeholder="Digite seu nome"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-field"
            />
          </div>

          <div className="input-group">
            <label className="select-label">Localização (Ex: Sala 10) *</label>
            <input
              type="text"
              placeholder="Onde está o problema?"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="input-field"
            />
          </div>

          <div className="form-grid">
            <div className="select-group">
              <label className="select-label">Selecione o Setor *</label>
              <select               
                value={sector}
                onChange={(e) => setSector(e.target.value)}
                className="select-field"
              >
                <option value="" disabled hidden>
                    Selecione o setor
                  </option>

                <option value="Pedagogico - Sala de Aula" >Pedagógico - Sala de Aula</option>
                <option value="Pedagogico - Coordenação">Pedagógico - Coordenação</option>
                <option value="Administrativo">Administrativo</option>
              </select>
            </div>

            <div className="select-group">
              <label className="select-label">Urgência *</label>
              <select
                value={urgency}
                onChange={(e) => setUrgency(e.target.value)}
                className="select-field"
              >
                <option value="" disabled hidden>
                    Selecione a urgência
                  </option>
                <option value="Urgente">Urgente</option>
                <option value="Alta">Alta</option>
                <option value="Normal">Normal</option>
                <option value="Baixa">Baixa</option>
              </select>
            </div>
          </div>

          <div className="input-group">
            <label className="select-label">Descrição do Problema *</label>
            <textarea
              placeholder="Detalhes do problema (ex: computador não liga...)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={4}
              className="input-field textarea-field"
            />
          </div>

          <button
            className="submit-button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Enviando..." : "Enviar Chamado"}
          </button>
        </div>
      </div>

      {/* POPUPS MANTIDOS */}
      {showPopup && (
        <div className="success-overlay">
          <div className="success-popup">
            <div className="success-icon">✓</div>
            <h2>Chamado Enviado!</h2>
            <p>Sua solicitação foi registrada com sucesso.</p>
          </div>
        </div>
      )}

      {showError && (
        <div className="success-overlay">
          <div className="success-popup warning">
            <h2>Campos Incompletos</h2>
            <p>Por favor, preencha todos os campos obrigatórios (*).</p>
            <button className="error-close-btn" onClick={() => setShowError(false)}>
              Corrigir agora
            </button>
          </div>
        </div>
      )}
    </div>
  );
}